import { CloseOutlineIcon } from '@carboncopyco/icons';
import type { Placement } from '@carboncopyco/ui';
import { TextBoxEditorTitle, Tooltip } from '@carboncopyco/ui';
import classNames from 'classnames';
import type React from 'react';

interface MenuFloatingProps {
  children: React.ReactNode;
  offset?: [number, number];
  title: string | React.ReactNode;
  onClose?: () => void;
  placement: Placement;
  visible?: boolean;
  toggleDropdown?: () => void;
  anchorRef: React.RefObject<HTMLElement>;
  isDraggable?: boolean;
  dragRef?: React.RefCallback<HTMLDivElement>;
}
export const MenuFloating = ({
  children,
  offset,
  title,
  onClose,
  visible,
  placement = 'bottom-start',
  anchorRef,
  isDraggable = false,
  dragRef,
}: MenuFloatingProps) => {
  return (
    <Tooltip
      anchorRef={anchorRef}
      placement={placement}
      offset={offset}
      noArrow
      visible={visible}
      interactive
      ref={dragRef}
    >
      <div className="bg-ds-accent3-100 box-border rounded-md shadow-ds-edit-tool p-5 w-[262px]">
        <div
          className={classNames(
            'handle-dragging flex items-center justify-between pb-5 box-border',
            isDraggable && 'cursor-move'
          )}
        >
          {typeof title === 'string' ? (
            <TextBoxEditorTitle
              label={title}
              uppercase
              fontWeight="font-ds-medium"
              color="text-ds-natural-300"
            />
          ) : (
            title
          )}
          <div
            className="cursor-pointer text-ds-natural-600"
            onClick={onClose}
          >
            <CloseOutlineIcon size={20} />
          </div>
        </div>
        {children}
      </div>
    </Tooltip>
  );
};
